import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { LoginPopupComponent } from 'src/app/shared/components/login-popup/login-popup.component';
import { BetService } from 'src/app/shared/services/bet.service';

@Component({
  selector: 'app-race-footer',
  templateUrl: './race-footer.component.html',
  styleUrls: ['./race-footer.component.scss'],
})
// @Sentry.TraceClassDecorator()
export class RaceFooterComponent implements OnInit {
  @Input() cuponInfo;
  @Input() raceDate;
  @Input() isFormValid: boolean;
  @Input() selectedBet: any;
  @Input() bettingSlipStatus: any;
  @Output() clearAll: EventEmitter<any>;

  bettingInfo = true;
  ref: DynamicDialogRef;
  allBetsOnCart$ = this.betService.allAddedBetsInCart$.asObservable();

  constructor(
    public betService: BetService,
    public authService: AuthService,
    public dialogService: DialogService
  ) {
    this.clearAll = new EventEmitter<any>(null);
  }

  ngOnInit(): void { }

  showConfirmBetPopup() {
    this.bettingInfo = false;
    this.authService
      .getCurrentUser()
      .pipe(take(1))
      .subscribe((currentUser) => {
        if (!currentUser) {
          this.ref = this.dialogService.open(LoginPopupComponent, {
            showHeader: true,
            dismissableMask: true,
            closable: true,
            styleClass: 'login-modal',
            data: {
              reload: false,
            },
            contentStyle: {
              'border-radius': '4px',
              padding: '0',
              'z-index': '999',
            },
          });
          this.ref.onClose.subscribe((loginSuccess?) => {
            if (loginSuccess) {
              this.betService.showConfirmBetPopupEvent$.next();
            }
          });
        } else {
          this.betService.showConfirmBetPopupEvent$.next();
        }
      });
  }

  increase(): void {
    this.betService.increase();
  }

  decrease(): void {
    this.betService.decrease();
  }

  clearBetSlip() {
    this.bettingInfo = false;
    this.clearAll.emit(true);
  }
}
